import dict from "../../Data/dict.json";

export const payment_type_to_name_of_license = (payment_type, language) => {
  let license_name = "";
  switch (payment_type) {
    case "license_1":
      license_name = "Personal";
      break;
    case "license_2":
      license_name = "Team";
      break;
    case "license_3":
      license_name = "Enterprise";
      break;
    case "license_academy":
      license_name = "Academy";
      break;
    case "data_exchange":
      license_name =
        dict?.["Payment data exchange"]?.[language];
      break;
    case "form":
      license_name = dict?.["Survey fee"]?.[language];
      break;
    default:
      if (
        ["personal", "team", "enterprise", "academy"].includes(payment_type)
      ) {
        license_name =
          payment_type?.[0]?.toUpperCase() + payment_type?.slice(1);
      }
      break;
  }
  return license_name;
}